<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>Χρήστες</u></h4>
        </div>
      </div>

      <div>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="grid-pad">
      <DxDataGrid
        :data-source="users"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-borders="true"
        key-expr="Id"
        @row-inserting="onRowInserting"
        @row-updating="onRowUpdating"
        @row-removing="onRowRemoving"
        @init-new-row="onInitNewRow"
        @editor-preparing="checkArea"
        :show-row-lines="true"
        :row-alternation-enabled="true"
      >
        <DxPaging :page-size="20" />
        <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="allowDeleting"
          :use-icons="true"
          mode="form"
        />
        <DxHeaderFilter :visible="true" />
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" />

        <!-- <DxColumn  caption="Κωδικός" data-field="Id" data-type="integer" :visible="false" :allow-editing="false">                           
                        </DxColumn> -->

        <DxColumn
          caption="ΑΦΜ"
          data-field="Afm"
          data-type="string"
          width="150px"
          alignment="left"
        >
          <DxRequiredRule message="το ΑΦΜ είναι υποχρεωτικό" />
          <DxAsyncRule
            :validation-callback="AFM_validation"
            message="AFM problem"
          />
        </DxColumn>

        <DxColumn
          caption="Email"
          data-field="Email"
          data-type="string"
          width="150px"
          :allow-editing="false"
          alignment="center"
          :visible="true"
        >
          <DxEmailRule message="Το email δεν έχει τη σωστή μορφή" />
        </DxColumn>

        <DxColumn
          caption="Επίθετο"
          data-field="LastName"
          data-type="string"
          alignment="left"
        >
          <DxRequiredRule message="το Επίθετο είναι υποχρεωτικό" />
        </DxColumn>

        <DxColumn
          caption="Ονομα"
          data-field="FirstName"
          data-type="string"
          alignment="left"
        >
          <DxRequiredRule message="το Όνομα είναι υποχρεωτικό" />
        </DxColumn>

        <DxColumn
          caption="Πρόσβαση"
          data-field="AreaId"
          data-type="int32"
          alignment="center"
          :visible="true"
        >
          <DxLookup :data-source="Areas" value-expr="Id" display-expr="name" />
          <DxRequiredRule message="Η περιοχή πρόσβασης είναι υποχρεωτική" />
        </DxColumn>

        <!-- <DxColumn caption="Συνθηματικό" data-field="Password" width="150px" alignment="center" :visible="false">
         <DxAsyncRule :validation-callback="Password_validation" message="Password problem" />
        </DxColumn> -->

        <DxColumn
          caption="Ενεργός"
          data-field="IsActive"
          data-type="boolean"
          width="120px"
          alignment="center"
          :read-only="true"
        >
        </DxColumn>

        <DxColumn
          caption="Ημ.Απενεργοποίησης"
          data-type="date"
          data-field="DeactivationDate"
          width="150px"
          alignment="center"
          :allow-editing="false"
          :visible="false"
        >
        </DxColumn>

        <DxColumn
          caption="Ημ.Αλλαγής Password"
          data-type="date"
          data-field="LastPasswordChangeDate"
          width="150px"
          alignment="center"
          :allow-editing="false"
          :visible="false"
        >
        </DxColumn>

        <DxColumn :visible="false" data-field="Notes" caption="Σημειώσεις">
          <DxFormItem
            :col-span="2"
            :editor-options="{ height: 100 }"
            editor-type="dxTextArea"
          />
        </DxColumn>

        <DxColumn type="buttons">
          <DxButton name="edit" />
          <DxButton
            hint="Φορείς Χρήστη"
            icon="repeat"
            :visible="isUserOrganizationsIconVisible"
            :on-click="userOrganizationsClick"
          />
          <DxButton name="delete" />
        </DxColumn>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxEditing,
  DxLookup,
  DxFormItem,
  DxRequiredRule,
  DxAsyncRule,
  DxButton,
  DxEmailRule,
} from "devextreme-vue/data-grid";
import "devextreme-vue/text-area";
import notify from "devextreme/ui/notify";
import BackButton from "../../components/shared/backButton";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxButton,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxEditing,
    DxLookup,
    DxFormItem,
    DxRequiredRule,
    DxAsyncRule,
    BackButton,
    DxLoadIndicator,
    DxEmailRule,
  },
  data() {
    return {
      Areas: [
        { Id: 1, name: "Super Admin" },
        { Id: 2, name: "EETAA" },
        { Id: 3, name: "Εκπρόσωπος" },
        { Id: 4, name: "Χρήστης" },
      ],
      AllowedAreas: [
        { Id: 1, name: "Super Admin" },
        { Id: 2, name: "EETAA" },
      ],
      users: [],
      loadIndicatorVisible: false,
      inputAttr: { id: "kokorikos" },
    };
  },
  computed: {
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },

  async mounted() {
    await this.getUsers();
  },
  methods: {
    checkArea(e) {
      if (e.parentType === "dataRow" && e.dataField === "AreaId") {
        if (this.isSuperAdmin || this.isAdmin) {
          e.editorOptions.dataSource = this.AllowedAreas;
        }
        if (e.value > 2) {
          e.editorOptions.dataSource = this.Areas;
          e.allowEditing = false;
          e.editorOptions.readOnly = true;
        }
      }
      if (
        e.parentType === "dataRow" &&
        !e.row.isNewRow &&
        (e.dataField === "LastName" ||
          e.dataField == "FirstName" ||
          e.dataField == "Afm")
      ) {
        e.editorOptions.readOnly = true;
      }
    },
    allowDeleting(e) {
      //debugger;
      return e.row.data.CanDelete;
    },
    async getUsers() {
      this.loadIndicatorVisible = true;
      const res = await mainService.get("/users/GetUsers");
      this.users = res.data;
      this.loadIndicatorVisible = false;
    },
    isUserOrganizationsIconVisible(e) {
      return e.row.data.AreaId == 2;
    },
    userOrganizationsClick(e) {
      var name = e.row.data.LastName + " " + e.row.data.FirstName;
      router.replace(`/userOrganizations/${e.row.data.Id}/${name}`);
    },
    onInitNewRow(e) {
      e.data.AreaId = 2;
      e.data.IsActive = true;
      e.data.Id = 0;
    },
    async onRowInserting(e) {
      var user = e.data;

      try {
        const res = await mainService.post("/users/AddUser", user);
        if (res.status != 200) {
          e.cancel = true;
          if (res.status == 400) {
            notify("Η αποθήκευση απέτυχε", "error", 5000);
          }
        }

        //await this.getUsers();

        notify("Η αποθήκευση πέτυχε", "success", 1000);
      } catch (error) {
        console.log(error);
        e.cancel = true;
        notify("Η αποθήκευση απέτυχε", "error", 1000);
      }

      await this.getUsers();
    },
    async onRowUpdating(e) {
      var user = Object.assign(e.oldData, e.newData);
      user.Id = e.key;

      try {
        const res = await mainService.post("/users/UpdateUser", user);
        if (res.status != 200) {
          e.cancel = true;
        }

        await this.getUsers();

        notify("Η αποθήκευση πέτυχε", "success", 1000);
      } catch (error) {
        console.log(error);
        e.cancel = true;
      }
    },
    async onRowRemoving(e) {
      const res = await mainService.delete(`/users/DeleteUser?id=${e.data.Id}`);
      if (res.status == 400) {
        notify("Ο χρήστης δεν μπορεί να διαγραφεί", "error", 5000);
      }
      if (res.data != true) {
        notify("Πρόβλημα κατά την Διαγραφή", "error", 5000);
      }
      await this.getUsers();
    },
    AFM_validation(params) {
      return new Promise((resolve, reject) => {
        mainService
          .get(`/users/CheckAfm?userId=${params.data.Id}&afm=${params.value}`)
          .then((res) => {
            res.data == "" ? resolve() : reject(res.data);
          })
          .catch((error) => {
            console.error("Server-side validation error", error);
            reject("Cannot contact validation server");
          });
      });
    },
    Password_validation(params) {
      debugger;
      return new Promise((resolve, reject) => {
        mainService
          .get(
            `/users/CheckUserPassword?password=${encodeURIComponent(
              params.value
            )}`
          )
          .then((res) => {
            res.data == "" ? resolve() : reject(res.data);
          })
          .catch((error) => {
            console.error("Server-side validation error", error);
            reject("Cannot contact validation server");
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dx-link-icon::v-deep {
  float: left !important;
}

.dx-datagrid::v-deep
  .dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  .dx-command-edit-with-icons
  .dx-link {
  width: 18px;
  height: 18px;
  background-position: 0 0;
  background-size: 18px 18px;
  padding: 0;
  font-size: 18px;
  text-align: center;
  line-height: 18px;
  margin: 0 3px;
}
</style>